import React from "react";
import { Layout, Menu, Button } from "antd";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import {
  HomeOutlined,
  AppstoreOutlined,
  UnorderedListOutlined,
  SettingOutlined,
  ShoppingCartOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import UserService from "../../Modules/Services/user.service.ts";

const { Sider } = Layout;

const AdminLayout = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    UserService.logout();
    navigate("/login");
  };

  const menuItems = [
    {
      key: "1",
      icon: <HomeOutlined />,
      label: <NavLink to="/admin/dashboard">Дашборд</NavLink>,
    },
    {
      key: "orders",
      icon: <ShoppingCartOutlined />,
      label: <NavLink to="/admin/orders">Заказы</NavLink>,
    },
    {
      key: "2",
      icon: <AppstoreOutlined />,
      label: <NavLink to="/admin/products">Товары</NavLink>,
    },
    {
      key: "3",
      icon: <UnorderedListOutlined />,
      label: <NavLink to="/admin/categories">Категории</NavLink>,
    },
    {
      key: "4",
      icon: <SettingOutlined />,
      label: <NavLink to="/admin/settings">Настройки</NavLink>,
    },
  ];

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider breakpoint="lg" collapsedWidth="0">
        <div style={{ padding: "16px", textAlign: "center" }}>
          <div style={{ fontWeight: 700, fontSize: 20, color: "#fff" }}>
            Админ-панель
          </div>
        </div>
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={["1"]}
          items={menuItems}
        />
      </Sider>
      <Layout>
        <Layout.Header
          style={{
            padding: "0 16px",
            background: "#fff",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <Button icon={<LogoutOutlined />} onClick={handleLogout}>
            Выйти
          </Button>
        </Layout.Header>
        <Layout.Content style={{ margin: "24px 16px 0" }}>
          <div
            style={{
              padding: 24,
              background: "#fff",
              minHeight: "calc(100vh - 184px)",
            }}
          >
            <Outlet />
          </div>
        </Layout.Content>
        <Layout.Footer style={{ textAlign: "center" }}>
          Shahrizadas Admin Panel ©{new Date().getFullYear()}
        </Layout.Footer>
      </Layout>
    </Layout>
  );
};

export default AdminLayout;
